export default __webpack_public_path__ + "static/media/signo-de-exclamacion.e208fb4f.svg";